module.exports = __webpack_public_path__ + "img/num02.af16b2fa.svg";